import React from "react";

function PointsTable() {
  return (
    <div className="pointstable">
      <div className="form">
      <h1>Points</h1>
      </div>
    </div>
  );
}

export default PointsTable;
